// App utils
import { datajsArray, datajsFirst } from '../shared/utils';

(function() {
	const shareContent = datajsFirst('share-content');
	const activatedCssClass = 'is-activated';
	const activeCssClass = 'is-active';

	const toggleShareContent = e => {
		if (shareContent.classList.contains(activatedCssClass) || shareContent.classList.contains(activeCssClass)) {
			hideShareContent();
		} else {
			showShareContent();
		}
	};

	const showShareContent = () => {
		shareContent.classList.add(activatedCssClass);

		setTimeout(function() {
			shareContent.classList.add(activeCssClass);
			shareContent.focus();
		}, 10);
	};

	const hideShareContent = () => {
		shareContent.classList.remove(activeCssClass);

		setTimeout(function() {
			shareContent.classList.remove(activatedCssClass);
		}, 500);
	};

	const shareToggle = () => {
		datajsArray('share-toggle').forEach(item => item.addEventListener('click', toggleShareContent));
	};

	document.addEventListener('DOMContentLoaded', shareToggle);
})();
